import { render } from "./Part_Navigation.vue?vue&type=template&id=68611711&scoped=true"
import script from "./Part_Navigation.vue?vue&type=script&lang=js"
export * from "./Part_Navigation.vue?vue&type=script&lang=js"

import "./Part_Navigation.vue?vue&type=style&index=0&id=68611711&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68611711"]])

export default __exports__